/**
 * Original work Copyright (c) 2021 Burst Apps Team
 */

/**
 * Constants for mining subtypes
 *
 * @module core
 */
export enum TransactionMiningSubtype {
    RewardRecipientAssignment = 0,
    AddCommitment = 1,
    RemoveCommitment = 2,
}

